import { useEffect, useState } from "react";
import LoadingApp from "../../../components/LoadingApp";
import { getOQueEOPrograma } from "../../../services/SaudeBemEstar/UnimeAcolheService";
import parse from 'html-react-parser';
import { useLocation, useNavigate } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@mui/material";
import { sxButton } from "./sxProps";

function OQueEUnimedAcolhe() {
    const [showLoading, setShowLoading] = useState<boolean>(false);
    const [texts, setTexts] = useState<string[]>(['', '', '']);
    const [showButton, setShowButton] = useState<boolean>(false);
    const accessibility = useAccessibility();
    const navigate = useNavigate(); 
    const location = useLocation();

    useEffect(() => {
        const getPrograma = async () => {
            setShowLoading(true);
            const result = await getOQueEOPrograma();
            if(result !== null){
                setTexts(result)
                setShowLoading(false)
            }
        }

        if(location.pathname.includes("boasVindas")){
            setShowButton(true);
        }
        getPrograma();
    }, []);

    const handleClick = () => {
        if(location.pathname.includes("boasVindas")){
            navigate('/saudeBemEstar/unimedAcolhe/inicio');
        }
        else {
            navigate('/saudeBemEstar/unimedAcolhe');
        }
        
    }

    const goBack = () => {
        if(location.pathname.includes("boasVindas")){
            navigate('/saudeBemEstar/unimedAcolhe');
        }
        else {
            navigate('/saudeBemEstar/unimedAcolhe/inicio');
        }
        
    }

    return (
        <div className="o-que-e-unimed-acolhe-holder">
            <LoadingApp showLoading={showLoading} />
            <h1 className="o-que-e-unimed-acolhe-title" style={accessibility.textTitleStyleAccessibility} >O que é o Unimed Acolhe?</h1>
            <p className="o-que-unimed-acolhe-part" style={accessibility.textStyleAccessibility}>
                {parse(texts[0])}
            </p>
            <div className={accessibility.contrastMode ? 'contrast-mode-o-que-unimed-acolhe-part' : 'o-que-unimed-acolhe-part' } style={accessibility.textStyleAccessibility}>
                {parse(texts[1])}
            </div>
            <div className="o-que-unimed-acolhe-part mb" style={accessibility.textStyleAccessibility}>
                {parse(texts[2])}
            </div>
            {showButton && 
                <div className="welcome-buttons-holder mb">
                    <div className="welcome-button">
                        <Button
                            variant="contained"
                            size="large"
                            onClick={handleClick}
                            sx={sxButton}
                            style={{...accessibility.buttonStyleAccessibility, ...accessibility.buttonTextStyleAccessibility}}
                            fullWidth>
                            CONTINUAR
                        </Button>
                    </div>
                </div>
            }
            <button className="what-is-it-back-button" style={accessibility.textStyleAccessibility} onClick={goBack} aria-label="Voltar para Unimed Acolhe">
                <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
            </button>
        </div>
    )
}

export default OQueEUnimedAcolhe;